const digest = '1f33a20e3a4d1b86550c19290d50109a824563df4995b9142bebcd4fa3573011';
const css = `._collapsibleOverlay_9onxa_1{height:100%;top:0;width:100%;z-index:10}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'collapsibleOverlay': '_collapsibleOverlay_9onxa_1' };
export const collapsibleOverlay = '_collapsibleOverlay_9onxa_1';
export { css, digest };